// extracted by mini-css-extract-plugin
export default {"theme_modal":"WebProfileModal_theme_modal__wkZXS","profile_img":"WebProfileModal_profile_img__Ktt9w","member_designation":"WebProfileModal_member_designation__auNfu"};